export default __webpack_public_path__ + "static/media/img3.65da85c4.jpg";